export default __webpack_public_path__ + "static/media/qblbasP23.db11bcde.jpg";